
// https://stackoverflow.com/questions/38100853/typescript-deserializing-json-into-collection-with-multiple-types

class NotificationItem {
    constructor(recommendationObj) {
        Object.keys(recommendationObj).map((key, index) => {
            this[key] = recommendationObj[key]
        });
    }
}

export enum NotificationTypes {
    V = 0,
    C = 1,
    RecommendationFixedIncome = 2
}

export class RecommendationBuy extends NotificationItem {
    constructor(recommendationObj) {
        super(recommendationObj)
    }
}

export class RecommendationSale extends NotificationItem {
    constructor(recommendationObj) {
        super(recommendationObj)
    }
}
    
export class RecommendationFixedIncome extends NotificationItem {
    constructor(recommendationObj) {
        super(recommendationObj)
    }
}